module.exports = __webpack_public_path__ + "img/ico-chev-up--orange.d36e851a.svg";